import { List } from "immutable";

import nativeCommsMessageTypes from "../../nativeComms/nativeCommsMessageTypes";
import {
  WINDOWS_KEY_LABEL_ALTERNATIVE as keyAlt,
  WINDOWS_KEY_LABEL_CONTROL as keyCtrl,
  WINDOWS_KEY_LABEL_SHIFT as keyShift
} from "./constants";
import toMenuItemRecord from "./toMenuItemRecord";
import { getShortCutString } from "./utils";

const selectionMenu = (state, disabledItems) => {
  return List([
    {
      label: "Select All",
      messageType: nativeCommsMessageTypes.SELECT_ALL,
      shortcut: getShortCutString([keyCtrl, "A"]),
      hasSeparator: true
    },
    {
      label: "Select First Item",
      messageType: nativeCommsMessageTypes.SELECT_FIRST_ITEM,
      shortcut: getShortCutString([keyCtrl, keyShift, "["])
    },
    {
      label: "Select Previous Item",
      messageType: nativeCommsMessageTypes.SELECT_PREVIOUS_ITEM,
      shortcut: getShortCutString([keyCtrl, "["])
    },
    {
      label: "Select Next Item",
      messageType: nativeCommsMessageTypes.SELECT_NEXT_ITEM,
      shortcut: getShortCutString([keyCtrl, "]"])
    },
    {
      label: "Select Last Item",
      messageType: nativeCommsMessageTypes.SELECT_LAST_ITEM,
      shortcut: getShortCutString([keyCtrl, keyShift, "]"]),
      hasSeparator: true
    },
    {
      label: "Select All Before Current Selection",
      messageType: nativeCommsMessageTypes.SELECT_ALL_BEFORE_CURRENT_SELECTION,
      shortcut: getShortCutString([keyCtrl, keyAlt, "["])
    },
    {
      label: "Select All After Current Selection",
      messageType: nativeCommsMessageTypes.SELECT_ALL_AFTER_CURRENT_SELECTION,
      shortcut: getShortCutString([keyCtrl, keyAlt, "]"])
    },
    {
      label: "Clear Selection",
      messageType: nativeCommsMessageTypes.SELECT_NONE,
      shortcut: getShortCutString([keyCtrl, keyAlt, "A"])
    }
  ]).map(item => toMenuItemRecord(item, disabledItems));
};

// Not implemented yet
// const bookmarksMenu = (state, disabledItems) => {
//   return List([
//     {
//       label: "Show Bookmarks",
//       shortcut: getShortCutString([keyCtrl, keyShift, "B"])
//     }
//   ]).map(item => toMenuItemRecord(item, disabledItems));
// };

export default (state, disabledItems) => {
  return List([
    {
      label: "Switch Focus",
      messageType: nativeCommsMessageTypes.SWITCH_FOCUS,
      disabled: false,
      shortcut: "Ctrl+Tab",
      hasSeparator: true
    },
    {
      label: "Scroll to Date",
      messageType: nativeCommsMessageTypes.SCROLL_TO_DATE,
      shortcut: getShortCutString([keyCtrl, "J"]),
      disabled: false
    },
    {
      label: "Scroll to Selected Event",
      messageType: nativeCommsMessageTypes.SCROLL_TO_SELECTION,
      shortcut: getShortCutString([keyCtrl, "G"]),
      disabled: false,
      hasSeparator: true
    },
    {
      label: "Selection",
      messageType: "selection",
      children: selectionMenu(state, disabledItems),
      disabled: false
    }
    // Not implemented yet
    // {
    //   label: "Bookmarks",
    //   children: bookmarksMenu(state, disabldItems),
    //   disabled: false
    // },
  ]).map(item => toMenuItemRecord(item, disabledItems));
};
